module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_video_data":"登録されたビデオがありません。","no_video_reviews":"ビデオレビューがありません。"}}')
  delete Component.options._Ctor
}
